import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ProductionTransitionArrow } from "../generic/common/ProductionTransitionArrow";
import { FontWithOutline } from "../generic/font-with-outline/FontWithOutline";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { RemainingTimeDisplay } from "../generic/remaining-time-display/RemainingTimeDisplay";
import { TextLoca } from "../generic/text/TextLoca";
export var ProductionTime = function (_a) {
    var time = _a.time;
    var isZero = time === 0;
    var remainingTime = isZero ? (React.createElement(FontWithOutline, { style: IdStyles.TextPositive },
        React.createElement(RemainingTimeDisplay, { seconds: 0 }))) : (React.createElement(RemainingTimeDisplay, { seconds: time, className: IdStyles.TextNormal }));
    return (React.createElement("div", { className: "context-menu-fixed-product-strip-arrow" },
        isZero ? React.createElement(TextLoca, { className: IdStyles.TextNormal, id: IdLoca.instant }) : undefined,
        React.createElement(ProductionTransitionArrow, null),
        React.createElement("div", { className: "context-menu-fixed-production-time flex flex--guts" },
            React.createElement(Icon, { icon: IdIcon.TimeIcn, styleId: IdStyles.IconSmall }),
            remainingTime)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/context-menu/ProductionTime.tsx
// module id = 2258
// module chunks = 3